import DataTableComponent from "../components/DataTableComponent";
import { columnsPayments, defaultFilters, metricsOpts, defaultUserPreferences, filtersRows, columnPaymentsMetrics } from "../utils/payments-data";
import React, { useEffect, useRef, useState } from 'react';
import { getDataApi } from "../services/apiService";
import Filters from "../components/filters/filters";


const PaymentPage = () => {
    const [data, setData] = useState({
        rows: [],
        totalRows: 0,
    })
    const [loading, setLoading] = useState({data: false, metrics: false})
    const [metrics, setMetrics] = useState([])
    const [columnsMetrics, setColumnsMetrics] = useState(columnPaymentsMetrics)
    const [metricsOptions, setMetricsOptions] = useState(metricsOpts)
	const [filters, setFilters] = useState(defaultFilters)
	const [userPreferences, setUserPreferences] = useState(defaultUserPreferences)
    const [groupMetrics, setGroupMetrics] = useState('method')
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10,
        sortDirection: null,
        sortField: null
    })

    const getData = async () => {
        setLoading(l => ({...l, data: true}))
        const response = await getDataApi(0, 
            'payment', 
            pagination.perPage * (pagination.page - 1), 
            pagination.perPage, 
            null, 
            null, 
            pagination.sortField, 
            pagination.sortDirection, 
            null,
            filters
        )
        if (response.result === 'ok') setData(prev => ({
            ...prev,
            totalRows: response.count,
            rows: response.data
        }))
        setLoading(l => ({...l, data: false}))
    }

    const getMetrics = async () => {
        setLoading(l => ({...l, metrics: true}))
        const response = await getDataApi(0, 
            'payment', 
            null, 
            null, 
            null, 
            null, 
            null, 
            null, 
            null,
            {
                ...filters,
                metrics: groupMetrics,
            }
        )
        if (response.result === 'ok') {

            const total = {[groupMetrics.split(".").at(-1)]: "TOTAL", amount: 0, payments: 0, bookings: 0}
    
            for (const row of response.data) {
    
                total.amount += row.amount
                total.payments += row.payments
                total.bookings += row.bookings
            }

            setMetrics([...response.data, total])
            setColumnsMetrics(columnPaymentsMetrics.filter(({field}) => total[field] !== undefined))
        }


        setLoading(l => ({...l, metrics: false}))
    }

    const handleRefresh = () => {
        getData()
        getMetrics()
    }

    const config = {
        page: 'paymentsPage',
		localStorageItem: 'payment-filters',
		filtersInterface: defaultFilters,
		preferencesInterface: defaultUserPreferences,
        rows: [
            [{ role: 'layout', inner: 'PAGOS' }, { key: 'update', action: handleRefresh }],
            ...filtersRows
        ]
    }

    useEffect(() => {
        handleRefresh()
    }, [filters])//eslint-disable-line

    useEffect(() => {
        getData()
    }, [pagination])//eslint-disable-line

    useEffect(() => {
        getMetrics()
    }, [groupMetrics])

    return (
        <div className="card">
            <div className="card-body">
                <Filters 
                    config={config}
                    onFilterChange={setFilters}
                    onPreferenceChange={setUserPreferences}
                />
                <hr />
                <DataTableComponent
                    model="payment-metrics"
                    title={`Métricas sumarizadas - ${metricsOptions.find((op) => op.value===groupMetrics).name}`}
                    noPagination
                    columns={columnsMetrics}
                    data={metrics}
                    totalRows={metrics.length}
                    loading={loading.metrics}
                    selectConfig={{
                        name: 'metrics',
                        selectId: 'slct-metrics',
                        options: metricsOptions,
                        setOptions: setMetricsOptions,
                        onInput: e => setGroupMetrics(e.target.value),
                        showCurrentValue: true,
                        selectAllOption: false,
                        defaultValue: 'method',
                        autoHide: true,
                        onlyOne: true,
                    }}
                />
                <hr />
                <DataTableComponent
                    model="payment"
                    title="Listado de pagos"
                    description="Listado de pagos tablao"
                    columns={columnsPayments}
                    data={data.rows}
                    totalRows={data.totalRows}
                    onChangePage={e => setPagination(prev => ({...prev, page: e}))}
                    onChangeRowsPerPage={(perPage, page) => setPagination(prev => ({...prev, perPage, page}))}
                    onSort={({field: sortField}, sortDirection) => setPagination(prev => ({...prev, sortDirection, sortField}))}
                    loading={loading.data}
                />
            </div>
        </div>
    )
}
export default PaymentPage;
